import Vue from 'vue'
import App from './App.vue'
import router from './router'
import rem from './utils/rem'
import VueWechatTitle from 'vue-wechat-title'
import {
	Toast
} from 'vant';
import {
	Popup
} from 'vant';
import {
	Picker
} from 'vant';
import {
	Field
} from 'vant';
import { Search } from 'vant';
import 'vant/lib/index.css';
import 'vue2-toast/lib/toast.css';
import Toast2 from 'vue2-toast';
import api from "./services/api"
import axios from 'axios'
import util from './utils/util';
import { Swipe, SwipeItem } from 'vant';
import { CountDown } from 'vant';
import IndexStore from "./store/Index";
import directives from './directive/index'
Vue.use(CountDown);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Toast2);
Vue.use(Search);
// vue.user(vconsole)

import {
	Switch
} from 'vant';
import {
	RadioGroup,
	Radio
} from 'vant';
Vue.use(Switch);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(VueWechatTitle)
Vue.use(Picker);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Toast);
import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)
Vue.config.productionTip = false;

router.beforeEach(async (to, form, next) => {
	// 小程序扫码出库跳转到H5
	if(to.query.from=='warehouseOut'){
		sessionStorage.setItem("OrgId", to.query.ErpOrgId);
		sessionStorage.setItem("warehouseOutData", to.query.queryData);
		IndexStore.state.CompanyName = JSON.parse(to.query.queryData).CompanyName;
		sessionStorage.setItem("QPT_UserToken", to.query.QPT_UserToken);
		let urlQuery = util.getStoObj("urlQuery");
		IndexStore.setVehicleTypeId(urlQuery.VehicleTypeId);
		IndexStore.setVin(urlQuery.Vin);
		IndexStore.setCarTypeName(decodeURIComponent(urlQuery.carTypeName||''));
	}else if (to.query.Eshop_DMSCode) {
		util.setStoObj("urlQuery", to.query);
		let urlQuery = util.getStoObj("urlQuery");
		IndexStore.setVehicleTypeId(urlQuery.VehicleTypeId);
		IndexStore.setVin(urlQuery.Vin);
		IndexStore.setCarTypeName(decodeURIComponent(urlQuery.carTypeName||''));
		
		util.setSto('DMSCode',urlQuery.Eshop_DMSCode)
		if(to.query.maindomain) {
			util.setStoObj('maindomain',to.query.maindomain)
		}
		if(to.query.orderapi) {
			util.setSto('orderapi',to.query.orderapi)
		}
		if(to.query.ErpOrgId){
			sessionStorage.setItem("OrgId", to.query.ErpOrgId);
		}
		if(to.query.contactsName) {
			util.setSto('contactsName',to.query.contactsName)
		}
		if(to.query.contactsMobile) {
			util.setSto('contactsMobile',to.query.contactsMobile)
		}
		if (to.query.QPT_UserToken) {
			//正式，生产环境
			sessionStorage.setItem("QPT_UserToken", to.query.QPT_UserToken);
			let userInfo = JSON.parse(to.query.QPT_UserInfo);
			delete userInfo.maindomain;
			util.setStoObj("allinfo", userInfo);
		} else if (to.query.Eshop_ShopCode) {
			//测试用，审核，生产环境不走这个逻辑
			let res = await api.loginQPT();
			let userInfo = res.Data.User;
			delete userInfo.DomainUrl;
			userInfo.DomainUrl = util.getStoObj("maindomain");
			util.setStoObj("allinfo", userInfo);
		}
	}
	
	
	//如果小程序有传递控制中心域名过来，h5页面就不请求控制中心接口
	if(util.getSto('orderapi')){
		axios.defaults.baseURL = util.getSto('orderapi');
		next()
	}else{
		if(util.getSto('DMSCode')) {
			api.GetErpDomainNameAll(util.getSto('DMSCode')).then(res => {
				let {
					orderapi,
					maindomain
				} = res.data
	
				axios.defaults.baseURL = orderapi;
	
				util.setStoObj('maindomain', maindomain)
				if (orderapi) {
					next()
				}else{
					Toast(err || "控制中心配置错误");
					console.error(err || "控制中心配置错误");
				}
			}).catch((err)=>{
				Toast(err || "系统繁忙");
				console.error(err || "系统繁忙");
			})
		}
	}

})
rem();
new Vue({
	router,
	render: (h) => h(App)
}).$mount('#app');